function createInput(event, value) {
    console.log('event.target', event.srcElement.activeElement.getAttribute('data-max'));

    let maxToSwitch = 7
    if (!!event.srcElement.activeElement.getAttribute('data-max')) {
      maxToSwitch = parseInt(event.srcElement.activeElement.getAttribute('data-max'))
    }
    if (value === maxToSwitch) {
        const form = event.target.activeElement.parentNode.parentNode
        const selectWrapper = event.target.activeElement.parentNode
        let inputElement = document.createElement('input');
        let inputElementWrapper = document.createElement('div');
        inputElementWrapper.className = 'form__input-wrapper select-wrapper--primary select-wrapper form__input-wrapper--featured';
        
        inputElement.id = event.target.id;
        inputElement.className = 'product-form__quantity form__field select__input-transform text-center';
        inputElement.pattern = '[0-9]*';
        inputElement.name = 'quantity';
        inputElement.value = `${maxToSwitch - 1}`;
        inputElement.min = '1'
    
        inputElementWrapper.appendChild(inputElement)
        form.replaceChild(inputElementWrapper,selectWrapper);
    }
}
document.addEventListener("qty:changed", function (e) {
    const value = parseInt(e.srcElement.activeElement.value);
    createInput(e, value)
});
